/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientResponseLanguageInner
 */
export interface PccPatientResponseLanguageInner {
    /**
     * 
     */
    languageDesc?: string;
}

/**
 * Check if a given object implements the PccPatientResponseLanguageInner interface.
 */
export function instanceOfPccPatientResponseLanguageInner(value: object): value is PccPatientResponseLanguageInner {
    return true;
}

export function PccPatientResponseLanguageInnerFromJSON(json: any): PccPatientResponseLanguageInner {
    return PccPatientResponseLanguageInnerFromJSONTyped(json, false);
}

export function PccPatientResponseLanguageInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientResponseLanguageInner {
    if (json == null) {
        return json;
    }
    return {
        
        'languageDesc': json['languageDesc'] == null ? undefined : json['languageDesc'],
    };
}

export function PccPatientResponseLanguageInnerToJSON(json: any): PccPatientResponseLanguageInner {
    return PccPatientResponseLanguageInnerToJSONTyped(json, false);
}

export function PccPatientResponseLanguageInnerToJSONTyped(value?: PccPatientResponseLanguageInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'languageDesc': value['languageDesc'],
    };
}

